<template>
<div>
  <div id="clouds">
    <!-- <div class="cloud x1"></div> -->
    <!-- Time for multiple clouds to dance around -->
    <div class="cloud x2"></div>
    <!-- <div class="cloud x3"></div> -->
    <div class="cloud x4"></div>
    <!-- <div class="cloud x5"></div> -->
  </div>
</div>
</template>

<script>

  export default {
    name: 'Cloud',
    props: ['title']
  }
</script>
  
<style lang="less">
@import "../../styles/global.less";

@keyframes bobCloud {
  0%   {  transform: translateY(0px); }
  50%   {   transform: translateY(-20px) }
  100% {  transform: translateY(0px); }
}

#clouds{
  position: fixed;
  left: 0;
  top: 0;

  width: 100vw;
  height: 100vh;

  z-index: -1;
}

.cloud {
  width: 200px; height: 60px;
  background: @black;
  
  border-radius: 200px;
  -moz-border-radius: 200px;
  -webkit-border-radius: 200px;
  
  position: absolute; 
}

.cloud:before, .cloud:after {
  content: '';
  position: absolute; 
  background: @black;
  width: 100px; height: 80px;
  position: absolute; top: -15px; left: 10px;
  
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
  -moz-transform: rotate(30deg);
}

.cloud:after {
  width: 120px; height: 120px;
  top: -55px; left: auto; right: 15px;
}

/*Time to animate*/
.x1 {
  display: none;
  -webkit-animation: moveclouds 15s linear infinite;
  -moz-animation: moveclouds 15s linear infinite;
  -o-animation: moveclouds 15s linear infinite;
}

/*variable speed, opacity, and position of clouds for realistic effect*/
.x2 {
  left: 200px;
  top: 80px;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  transform: scale(1.5);
  
  /*Speed will also be proportional to the size and opacity*/
  /*More the speed. Less the time in 's' = seconds*/
  -webkit-animation: bobCloud 4s linear infinite;
  -moz-animation: bobCloud 4s linear infinite;
  -o-animation: bobCloud 4s linear infinite;
}

.x3 {
  display: none;
  left: -250px; top: 500px;
  
  -webkit-transform: scale(0.8);
  -moz-transform: scale(0.8);
  transform: scale(0.8);
  
  -webkit-animation: moveclouds 40s linear infinite;
  -moz-animation: moveclouds 40s linear infinite;
  -o-animation: moveclouds 40s linear infinite;
}

.x4 {
  left: 470px; top: 100px;
  
  -webkit-transform: scale(3);
  -moz-transform: scale(3);
  transform: scale(3);
  
  -webkit-animation: moveclouds 60s linear infinite;
  -moz-animation: moveclouds 60s linear infinite;
  -o-animation: moveclouds 60s linear infinite;
}

.x5 {
  left: -150px; top: -150px;
  
  -webkit-transform: scale(0.8);
  -moz-transform: scale(0.8);
  transform: scale(0.8);
  opacity: 0.8; /*opacity proportional to the size*/
  
  -webkit-animation: moveclouds 20s linear infinite;
  -moz-animation: moveclouds 20s linear infinite;
  -o-animation: moveclouds 20s linear infinite;
}

@-webkit-keyframes moveclouds {
  0% {margin-left: 100vw}
  100% {margin-left: -100vw}
}
@-moz-keyframes moveclouds {
  0% {margin-left: 100vw}
  100% {margin-left: -100vw}
}
@-o-keyframes moveclouds {
  0% {margin-left: 100vw}
  100% {margin-left: -100vw}
}

</style>





// WEBPACK FOOTER //
// src/components/library/cloud.vue